import React from "react";
import { FaPython} from "react-icons/fa";
import {
  SiMongodb,
  SiPhp,
  SiGit,
  SiDjango,
  SiCodeigniter,
  SiMysql,
} from "react-icons/si";

const SkillCard = () => {
  return (
    <>
      <div
        className="text-white flex flex-col items-center justify-center w-28 h-32 rounded-md font-semibold cursor-pointer transition-all ease-in-out duration-500 hover:-translate-y-4"
        style={{ boxShadow: "1px 1px 4px 4px #1aba95" }}
      >
        <SiCodeigniter size={48} />
        <p>Codeigniter</p>
      </div>

      {/* for css */}
      <div
        className="text-white flex flex-col items-center justify-center w-28 h-32 rounded-md font-semibold cursor-pointer transition-all ease-in-out duration-500 hover:-translate-y-4"
        style={{ boxShadow: "1px 1px 4px 4px #1aba95" }}
      >
        <SiDjango size={48} />
        <p>Django</p>
      </div>

      <div
        className="text-white flex flex-col items-center justify-center w-28 h-32 rounded-md font-semibold cursor-pointer transition-all ease-in-out duration-500 hover:-translate-y-4"
        style={{ boxShadow: "1px 1px 4px 4px #1aba95" }}
      >
        <SiPhp size={48} />
        <p>Php</p>
      </div>

      {/* for express */}
      <div
        className="text-white flex flex-col items-center justify-center w-28 h-32 rounded-md font-semibold cursor-pointer transition-all ease-in-out duration-500 hover:-translate-y-4"
        style={{ boxShadow: "1px 1px 4px 4px #1aba95" }}
      >
        <FaPython size={48} />
        <p>Python</p>
      </div>

      {/* for mongodb */}
      <div
        className="text-white flex flex-col items-center justify-center w-28 h-32 rounded-md font-semibold cursor-pointer transition-all ease-in-out duration-500 hover:-translate-y-4"
        style={{ boxShadow: "1px 1px 4px 4px #1aba95" }}
      >
        <SiMongodb size={48} />
        <p>MongoDB</p>
      </div>

      {/* for mysql */}
      <div
        className="text-white flex flex-col items-center justify-center w-28 h-32 rounded-md font-semibold cursor-pointer transition-all ease-in-out duration-500 hover:-translate-y-4"
        style={{ boxShadow: "1px 1px 4px 4px #1aba95" }}
      >
        <SiMysql size={48} />
        <p>Mysql</p>
      </div>

      {/* for git */}
      <div
        className="text-white flex flex-col items-center justify-center w-28 h-32 rounded-md font-semibold cursor-pointer transition-all ease-in-out duration-500 hover:-translate-y-4"
        style={{ boxShadow: "1px 1px 4px 4px #1aba95" }}
      >
        <SiGit size={48} />
        <p>Git</p>
      </div>
    </>
  );
};

export default SkillCard;
